export default __webpack_public_path__ + "static/media/postgresql-backup-negative.fc40d56c.svg";